"use client";
import cn from "clsx";
import { PagingParams, PaginationParams } from "@/components/layout/layoutType";
import { Button, Flex } from "@radix-ui/themes";

import Icon from "@/components/common/icon/icon";
import DataInput from "../dataInput";
import { Color } from "antd/es/color-picker";
// import dynamic from "next/dynamic";
// const Icon = dynamic(() => import("@/components/common/icon/icon"), { ssr: false });

export default function Pagination(params: PagingParams) {
  if (params.paging == null) {
    return <></>;
  } else {
    const page_count = params.pagingCount ?? 5;
    const page_arr = [];

    const start = Math.floor((params.paging.page - 1) / page_count) * page_count + 1;
    const page_end = Math.floor((params.paging.page - 1) / page_count) * page_count + page_count;
    const end = params.paging.total_pages < page_end ? params.paging.total_pages : page_end;
    for (let i = start; i <= end; i++) {
      page_arr.push(i);
    }

    return (
      <>
        <Flex align="center" gap={params.gap} className={cn("justify-end max-w-full overflow-x-auto overflow no-scrollbar")}>
          <Button
            type="button"
            aria-label="Page Count"
            variant="ghost"
            disabled
            className={cn(params.buttonClassName, "")}
            style={{ color: "var(--gray-12)" }}
            onClick={(e) => {
              params.setpage(params.paging.total_pages);
            }}
          >
            {(params.paging.page - 1) * params.paging.list_count +
              1 +
              ((params.paging.page - 1) * params.paging.list_count + 1 !==
              Math.min(params.paging.page * params.paging.list_count, params.paging.total_count)
                ? " - " + Math.min(params.paging.page * params.paging.list_count, params.paging.total_count)
                : "") +
              " / " +
              params.paging.total_count}
          </Button>
        </Flex>
        <Flex align="center" gap={params.gap} className={cn(params.className, " max-w-full overflow-x-auto overflow no-scrollbar")}>
          <Button
            type="button"
            aria-label={`First Page`}
            variant="soft"
            className={cn(start == 1 ? "invisible_" : "cursor-pointer", params.buttonClassName)}
            disabled={start == 1}
            onClick={(e) => {
              params.setpage(1);
            }}
          >
            <Icon iconType="phosphor" iconName="SkipForward" className="rotate-180" />
          </Button>
          <Button
            type="button"
            aria-label={`Prev Page`}
            variant="soft"
            className={cn(start == 1 ? "invisible_" : "cursor-pointer", params.buttonClassName)}
            disabled={start == 1}
            onClick={(e) => {
              params.setpage(start - 1);
            }}
          >
            <Icon iconType="phosphor" iconName="Play" className="rotate-180" />
          </Button>{" "}
          {page_arr.map((item, index) => {
            return (
              <Button
                type="button"
                aria-label={`Page ${item}`}
                variant="soft"
                key={"pagelink_" + index}
                className={cn("cursor-pointer", item == params.paging.page ? params.activeButtonClassName : params.buttonClassName)}
                onClick={(e) => {
                  params.setpage(item);
                }}
              >
                {item}
              </Button>
            );
          })}
          <Button
            type="button"
            aria-label="Next Page"
            variant="soft"
            className={cn(end == params.paging.total_pages ? "invisible_" : "cursor-pointer", params.buttonClassName)}
            disabled={end == params.paging.total_pages}
            onClick={(e) => {
              params.setpage(end + 1);
            }}
          >
            <Icon iconType="phosphor" iconName="Play" />
          </Button>
          <Button
            type="button"
            aria-label="Last Page"
            disabled={end == params.paging.total_pages}
            variant="soft"
            className={cn(end == params.paging.total_pages ? "invisible_" : "cursor-pointer", params.buttonClassName)}
            onClick={(e) => {
              params.setpage(params.paging.total_pages);
            }}
          >
            <Icon iconType="phosphor" iconName="SkipForward" />
          </Button>
        </Flex>
      </>
    );
  }
}
